import { render, staticRenderFns } from "./EditBabyName.vue?vue&type=template&id=be95331a&scoped=true&"
import script from "./EditBabyName.vue?vue&type=script&lang=js&"
export * from "./EditBabyName.vue?vue&type=script&lang=js&"
import style0 from "./EditBabyName.vue?vue&type=style&index=0&id=be95331a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be95331a",
  null
  
)

export default component.exports